import { render, staticRenderFns } from "./projects-charts-exp.component.vue?vue&type=template&id=fed5504a&scoped=true&"
import script from "./projects-charts-exp.component.vue?vue&type=script&lang=js&"
export * from "./projects-charts-exp.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed5504a",
  null
  
)

export default component.exports